import { makeStyles } from "@material-ui/styles";

const useLinkListAccordionStyles = makeStyles((theme) => ({
  linkList: {
    width: "100%",
    padding: 0,
  },
  linkItem: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  linkAnchor: {
    color: "#333",
    display: "inline-flex",
    alignItems: "center",
    fontSize: 14,
    lineHeight: 1.4,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  linkIcon: {
    width: 16,
    height: 16,
    marginRight: theme.spacing(0.75),
    objectFit: "contain",
    marginTop: 2,
  },
  linkTextWrap: {
    display: "flex",
    flexDirection: "column",
  },
  linkLabel: {
    fontSize: 14,
    lineHeight: 1.4,
  },
  linkNote: {
    fontSize: 12,
    lineHeight: 1.35,
    color: "#666",
  },
  noLinksText: {
    fontSize: 13,
    color: "#666",
  },
}));

export default useLinkListAccordionStyles;
